import { TRANSITION_END } from '../core'

$.fn.GallerySlide = function(gallery) {
  let self = this
  self.picture = self.find('.picture')
  self.ratio = self.picture.width() / self.picture.height()

  self.initialize = function() {
    if (self.ratio < 1.52) {
      self.css({
        width: 'calc(' + (100 * self.ratio / 1.52) + '% - 40px)',
      })
    }
  }

  return function() {
    self.initialize()
    return self
  }()
}

$.fn.Gallery = function() {
  let self = this
  self.slides = []
  self.index = 0
  self.previousSlide = undefined
  self.animating = false
  self.buffer = 0

  self.clicked = function() {
    if (self.animating) {
      self.buffer += 1
      return
    }
    self.animating = true
    let lastSlide = self.slides[self.slides.length - 1],
    currentTop = parseInt(lastSlide.css('top'))
    lastSlide.removeClass('current').css({
      top: (currentTop / 2) + 'px',
      transform: 'translateX(-800px)',
    }).on(TRANSITION_END, function() {
      lastSlide.off(TRANSITION_END).css({
        top: '0px',
        transform: 'translateX(0px)',
        zIndex: 0,
      })
      self.slides.forEach(function(slide, index) {
        if (slide != lastSlide) {
          slide.css({
            top: (parseInt(slide.css('top'), 10) + 40) + 'px',
            zIndex: parseInt(slide.css('z-index'), 10) + 1,
          })
        }
      })
      self.slides.unshift(self.slides.pop())
      self.slides[self.slides.length - 1].addClass('current')
      self.animating = false
      if (self.buffer) {
        self.buffer -= 1
        self.clicked()
      }
    })
  }

  self.position = function() {
    self.slides.forEach(function(slide, index) {
      let posX, posY, zIndex
      if (self.previousSlide == undefined) {
        posX = 0
        posY = 0
      } else {
        if (index % 2) {
          posX = self.previousSlide.offset().left - self.offset().left + 40
        } else {
          posX = self.previousSlide.offset().left + self.previousSlide.width() - self.offset().left - 40 - slide.width()
        }
        posY = index * 40
      }
      slide.css({
        'position': 'absolute',
        'left': posX + 'px',
        'top': posY + 'px',
        'z-index': index,
      })
      self.previousSlide = slide
      if (self.height() < slide.height() + posY) {
        self.height(slide.height() + posY)
      }
    })
    self.addClass('gallery--animated')
  }

  self.initialize = function() {
    self.find('.gallery__item').each(function(el, index) {
      let slide = $(this).GallerySlide()
      self.slides.push(slide)
    })
    self.on('click', self.clicked)
    self.position()
    self.slides[self.slides.length - 1].addClass('current')
  }

  return function() {
    self.initialize()
    return self
  }()
}
